import { z } from 'zod';
import { MAX_SALES_ORDER_LINE_LIST } from './max-sales-order-line-list.js';
const hasUniqueLines = (rows) => new Set(rows.map((row) => row.salesOrderItemId)).size === rows.length;
export const uniqueLineList = (row) => z
    .array(row)
    .max(MAX_SALES_ORDER_LINE_LIST, `At most ${MAX_SALES_ORDER_LINE_LIST} lines per request.`)
    .refine(hasUniqueLines, 'Each line can appear only once.');
//# sourceMappingURL=unique-line-list.js.map